/* eslint-disable no-underscore-dangle */
import React, { useCallback } from 'react';
import cx from 'classnames';

import { AdvancedMarker, InfoWindow } from '@vis.gl/react-google-maps';

import moment from 'moment';

const UserMarker = ({ user, map, setSelectedUserId, selectedUserId, project, setMarkers }) => {
  const position = {
    lat: Number(user.latitude),
    lng: Number(user.longitude),
  };

  const panToUserLocation = useCallback(() => {
    if (!map) return;
    if (map.getZoom() < 15) map.setZoom(15);
    setTimeout(() => map.setCenter({ lat: user.latitude, lng: user.longitude }), 100);
    setSelectedUserId(user.user.id);
  }, [map, user]);

  const handleRef = useCallback(
    (node) => {
      setMarkers((prevMap) => {
        if (prevMap.get(user.user.id) === node) return prevMap; // No change, skip update
        const newMap = new Map(prevMap);
        if (node) newMap.set(user.user.id, node);
        else newMap.delete(user.user.id);
        return newMap;
      });
    },
    [user.user.id]
  );

  return (
    <AdvancedMarker
      ref={handleRef}
      position={position}
      onClick={panToUserLocation}
      zIndex={selectedUserId === user.user.id ? 200 : 50}
    >
      {selectedUserId === user.user.id && (
        <InfoWindow
          position={position}
          headerDisabled
          maxWidth={250}
          pixelOffset={[18, -60]}
          shouldFocus={false}
        >
          <div className="flex mb-4">
            <div
              style={{
                backgroundColor:
                  user.status === 'ACTIVE' ? project?.accent_colour || '#37C2D7' : '#434C5899',
              }}
              className="z-20 w-8 h-8 relative rounded-full text-white text-base/13 text-center shrink-0"
            >
              {user.user.name.includes(' ') ? user.user.name?.split(' ')[0][0] : user.user.name[0]}
              {user.user.name.includes(' ') && user.user.name?.split(' ')[1][0]}
            </div>
            <span className="my-auto mx-2 text-lg font-medium truncate">{user.user.name}</span>
            <button
              className="absolute top-3 right-3"
              type="button"
              onClick={() => setSelectedUserId(undefined)}
            >
              <svg
                width="22"
                height="22"
                viewBox="0 0 22 22"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="11" cy="11" r="11" fill="#F4F5F7" />
                <path
                  d="M14.8874 13.531L12.3566 11.0003L14.8874 8.46955C15.2678 8.08912 15.2678 7.49365 14.8874 7.11321C14.5069 6.73277 13.9115 6.73277 13.531 7.11321L11.0003 9.64395L8.46955 7.11321C8.08912 6.73277 7.49365 6.73277 7.11321 7.11321C6.73277 7.49365 6.73277 8.08912 7.11321 8.46955L9.64395 11.0003L7.11321 13.531C6.73277 13.9115 6.73277 14.5069 7.11321 14.8874C7.49365 15.2678 8.08912 15.2678 8.46955 14.8874L11.0003 12.3566L13.531 14.8874C13.9115 15.2678 14.5069 15.2678 14.8874 14.8874C15.2678 14.5069 15.2678 13.9115 14.8874 13.531Z"
                  fill="#434C58"
                />
              </svg>
            </button>
          </div>
          <div className="my-3">
            <span className="font-normal">Project: </span>
            <span>{user.user?.project?.name}</span>
          </div>

          <div className="my-3">
            <span className="font-normal">Coordinates: </span>
            <span>
              {user.latitude}, {user.longitude}
            </span>
          </div>
          <div className="my-3">
            <span className="font-normal">
              {user.status === 'ACTIVE' ? 'Location Updated: ' : 'Location Sharing Ended: '}
            </span>
            <span>{moment(user.lastUpdated).format('MMM Do, YYYY, HH:mm')}</span>
          </div>
        </InfoWindow>
      )}
      <div
        style={{
          backgroundColor:
            user.status === 'ACTIVE' ? project?.accent_colour || '#37C2D7' : '#CCCCCC',
        }}
        className={cx(
          'z-20 w-8 h-8 top-[27px] left-[22px] relative rounded-full text-lg/12 text-center',
          {
            'text-white': user.status === 'ACTIVE',
            'text-[#888B8B]': user.status !== 'ACTIVE',
          }
        )}
      >
        {user.user.name.includes(' ') ? user.user.name?.split(' ')[0][0] : user.user.name[0]}
        {user.user.name.includes(' ') && user.user.name?.split(' ')[1][0]}
      </div>
      {/* <img className="relative bottom-3.75 left-4.5" src={userIcon} alt="" /> */}
      <div
        className={cx(
          'relative bottom-[9px] left-[18px] w-[40px] h-[40px] rounded-t-full rounded-br-full rounded-bl-[5999999px]',
          {
            'bg-[#434C58]': user.status === 'ACTIVE',
            'bg-[#888B8B]': user.status !== 'ACTIVE',
          }
        )}
      />
    </AdvancedMarker>
  );
};

export default UserMarker;
